function insertElOpus() {
 const targetItem = document.querySelector('div.cd-upsell-title > p');

  if (targetItem) {

    targetItem.style.display = 'flex';
    targetItem.style.alignItems = 'center';
    targetItem.style.gap = '10px';

    targetItem.insertAdjacentHTML(
      'afterend',
      `<img
          src="https://pt-product-page.vercel.app/_next/static/media/chevrons-down.1c13f383.svg"
          alt="Icon"
          style="width: 15px; height: 15px; object-fit: contain"
        />`
    );

    targetItem.insertAdjacentHTML(
      'beforebegin',
      `<img
          src="https://pt-product-page.vercel.app/_next/static/media/chevrons-down.1c13f383.svg"
          alt="Icon"
          style="width: 15px; height: 15px; object-fit: contain"
        />`
    );
  } 
  const rewardsItem = document.querySelector('.cd-product-item');
  const insertedElement = document.querySelector('.custom-info-container');

  if (rewardsItem && !insertedElement) {

    if (insertedElement) {
      insertedElement.remove();
    }
     document.querySelector('.cd-checkout-section-button').insertAdjacentHTML(
    "afterend",
   `<div style="display: flex; justify-content: center;align-items: center;font-size: 11px;padding-top: 8px;">
      <svg width="9" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.805 4.163h-.669V3.27c0-1.722-1.4-3.123-3.122-3.123A3.126 3.126 0 0 0 .892 3.271v.892H.223c-.123 0-.223.1-.223.223V9.96c0 .492.4.892.892.892h6.244c.492 0 .892-.4.892-.892V4.386c0-.124-.1-.223-.223-.223ZM4.682 8.82a.224.224 0 0 1-.222.248h-.892a.223.223 0 0 1-.222-.248l.141-1.265a.882.882 0 0 1-.365-.717.893.893 0 0 1 1.784 0 .882.882 0 0 1-.365.717l.14 1.265Zm1.116-4.658H2.23V3.27c0-.984.8-1.785 1.784-1.785s1.784.8 1.784 1.785v.892Z" fill="#2E2E2E"></path>
      </svg>
      &nbsp;100% Secured by&nbsp;
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="18" viewBox="0 0 37 20">
        <g fill="#000">
          <path d="M35.607 4.675h-1.984a.39.39 0 0 1-.392-.39v-1.99a.39.39 0 0 1 .393-.388h1.984a.39.39 0 0 1 .392.389v1.991a.39.39 0 0 1-.393.389m-2.573-2.77h-.992a.196.196 0 0 1-.196-.195V.715c0-.107.088-.194.196-.194h.993c.108 0 .196.087.196.195v.995a.196.196 0 0 1-.197.195M22.115 7.907l-1.836 7.396c-.538 2.168-1.458 3.099-3.174 3.212a1.424 1.424 0 0 1-.125.006c-.37 0-.487-.206-.556-.537l-.031-.144c-.032-.151-.051-.32.036-.439.085-.114.236-.147.47-.167 1.149-.119 1.539-.654 1.922-1.867-.182.061-.4.094-.636.094-1.263 0-1.6-.886-1.885-1.956l-1.517-5.594c-.05-.19-.084-.383.015-.512.098-.13.29-.147.483-.147h.127c.477 0 .66.141.784.606l1.5 5.545c.195.692.39.809.877.809.397 0 .63-.125.795-.806l1.324-5.545c.106-.461.293-.61.77-.61h.143c.192 0 .382.018.483.146.101.128.075.32.031.51zm-9.266 3.75h-1.766c-1.42 0-1.974.364-1.974 1.297 0 .85.552 1.264 1.687 1.264 1.717 0 2.053-.529 2.053-1.441v-1.12zm-2.053-4.64c2.323 0 3.453.858 3.453 2.625v3.183c0 1.827-1.06 2.642-3.437 2.642-2.001 0-3.103-.893-3.103-2.513 0-1.671 1.067-2.45 3.358-2.45h1.782v-.862c0-.966-.577-1.36-1.99-1.36-.786 0-1.506.117-1.73.174a1.02 1.02 0 0 1-.245.035c-.141 0-.246-.05-.31-.151-.057-.086-.083-.209-.083-.385v-.129c0-.451.165-.56.559-.646.223-.045.81-.164 1.746-.164zm-4.491 1.07c0 1.331-.337 2.052-2.117 2.052h-2.74V6.706c0-.476.176-.653.649-.653h2.09c1.342 0 2.118.333 2.118 2.035zM4.188 4.675H1.825C.563 4.675 0 5.241 0 6.513v8.166c0 .49.157.649.644.649h.16c.488 0 .644-.158.644-.65v-3.176h2.74c2.432 0 3.565-1.085 3.565-3.414 0-2.328-1.133-3.413-3.565-3.413z"></path>
          <path d="M23.732 5.312c.935 0 1.283.159 1.283 1.036v2.513l.001.023v2.89c0 .35.066.629.202.845.255.404.76.588 1.568.59.807-.002 1.312-.186 1.567-.59.136-.217.201-.496.201-.846V8.908l.001-.046v-.45l.001-.013V6.348c0-.877.348-1.036 1.284-1.036h.294c.164 0 .31.005.438.018l-.001 1.7a.38.38 0 0 0 .376.384h.47v4.36c0 .873-.191 1.612-.56 2.208-.715 1.155-2.098 1.77-4.064 1.77h-.015c-1.966 0-3.35-.615-4.063-1.77-.37-.596-.561-1.335-.561-2.208V6.348c0-.877.348-1.036 1.283-1.036h.295zm9.122-.636a.38.38 0 0 1 .377.384v1.97c0 .213-.17.385-.378.385l-1.436-.001V6.348c0-.724-.236-.958-.845-1.018v-.27a.38.38 0 0 1 .376-.385h1.906z"></path>
        </g>
      </svg>
    </div>
    `
   );

    rewardsItem.insertAdjacentHTML(
      'beforebegin',
      `<div class="custom-info-container" style="display: flex; justify-content: space-between; align-items: center; gap: 15px; margin: 0 20px;">
        <div style="display: flex; text-align: center; font-size: 13px; flex-direction: column; align-items: center;">
          <img
            src="https://cdn.shopify.com/s/files/1/0882/6640/8217/files/Shipping.png?v=1736246581"
            alt="Free Shipping"
            style="width: 30px; height: 30px; object-fit: contain; margin-bottom: 5px;"
          />
          <p style="margin: 0; font-weight: 500;">Free Shipping</p>
        </div>
        <div style="display: flex; text-align: center; font-size: 13px; flex-direction: column; align-items: center;">
          <img
            src="https://cdn.shopify.com/s/files/1/0882/6640/8217/files/Homemade.png?v=1736246293"
            alt="100% Handmade"
            style="width: 30px; height: 30px; object-fit: contain; margin-bottom: 5px;"
          />
          <p style="margin: 0; font-weight: 500;">100% Handmade</p>
        </div>
        <div style="display: flex; text-align: center; font-size: 13px; flex-direction: column; align-items: center;">
          <img
            src="https://cdn.shopify.com/s/files/1/0882/6640/8217/files/COD_Available.png?v=1736246291"
            alt="COD Available"
            style="width: 30px; height: 30px; object-fit: contain; margin-bottom: 5px;"
          />
          <p style="margin: 0; font-weight: 500;">COD Available</p>
        </div>
        <div style="display: flex; text-align: center; font-size: 13px; flex-direction: column; align-items: center;">
          <img
            src="https://cdn.shopify.com/s/files/1/0882/6640/8217/files/Made-in-india.png?v=1736245078"
            alt="Proudly Indian"
            style="width: 30px; height: 30px; object-fit: contain; margin-bottom: 5px;"
          />
          <p style="margin: 0; font-weight: 500;">Proudly Indian</p>
        </div>
      </div>`
    );
  }
}

window.addEventListener('OpusCartChange', (event) => {
  insertElOpus();
  const data = event.detail;
  const findSelectEl = document.querySelector('.opus-price-ct-container');
  
  if (findSelectEl) {
    findSelectEl.remove();
  }

  const isPriceDiscount = data.original_total_price - data.total_price > 0;
  
  document.querySelector('.cd-checkout-section-button').insertAdjacentHTML(
    "beforebegin",
    `<div class="opus-price-ct-container" style="display: flex; justify-content: space-between; font-size: 16px; font-weight: bold; width: 100%; gap: 20px;">
      <span style="flex-shrink: 0; margin-right: 2.5vw; color: black;">
        <strong>Total Summary</strong>
      </span>
      <span style="text-align: right; flex-grow: 1; color: black;">
        ${data.money}
        <span style="font-size: 14px; color: grey; text-decoration: line-through; font-weight: 500; margin-left: 5px;">
          ${isPriceDiscount ? data.oPriceMoney : ''}
        </span>
      </span>
    </div>`
  );


  document.querySelector('.cd-checkout-section-button').textContent = 'Proceed to Place Order';
});

window.addEventListener('OpusCartChange', (event) => {
  const count = event.detail?.item_count;

  if (typeof count === 'number') {
    // Cập nhật trên .header--cart
    const cartIcon = document.querySelector('.header--cart');
    if (cartIcon) {
      cartIcon.setAttribute('data-cart-count', count);
    }

    // Nếu cần, cũng cập nhật .inner-count
    const countEl = document.querySelector('.inner-count');
    if (countEl) {
      countEl.textContent = count;
      countEl.setAttribute('data-cart-count', count);
    }
  }
});





